import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import styles from './../SuperSearch.module.css';
import isNull from "../../../../utils/NullChecking";
import InitialLetters from "../../../../utils/InitialLetters";
import { useSelector } from 'react-redux';
import { isFemale, isMale } from '../../../../utils/Gender';
import useSuperSearchMultipleFunctions from './hooks/useSuperSearchMultipleFunctions';
import AmountFormatter from '../../../../utils/AmountFormatter';
import HandleStatus from '../../HandleStatus';
import { PhoneNumberFormat } from '../SuperSearchList';

const SuperSearchMultipleServer = (props) => {
  const { searchParam, setSearchParam, initialSelectedOptionsInstant, setSelectedPatientOptions = () => { }, controller, ApiLink, method, name, tableName, postBody, type } = props;

  let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
  const isHomeCareCheck = DropDowns.IsHomeCare;
  let datainstant = []
  let counter = 0; // to maintain the index 
  let bool;  // to check if the arrow is changed from down to up or from up to down (so we should inc or dec)
  let lastKeyPressed; // to check weather counter should be incremented or decremented

  const [isListOpen, setIsListOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [options, setOptions] = useState([]);
  let { isLoading, onSelect, fetchOptions, SearchLetterHighlighted } = useSuperSearchMultipleFunctions(searchParam, setSearchParam, setOptions, controller, ApiLink, method, tableName, postBody, type);
  const [selectedOptionsInstant, setSelectedOptionsInstant] = useState(initialSelectedOptionsInstant || []);
  // const [noResult, setNoResult] = useState(false);
  const wrapperRef = useRef(null);
  const listRef = useRef(null);
  const buttonRef = useRef(null);

  const chipsWrapRef = useRef(null);
  const [chipRowCount, setChipRowCount] = useState(1);
  const ROW_HEIGHT = 25;

  const calculateChipRows = () => {
    const container = chipsWrapRef.current;
    if (!container) return;

    const items = Array.from(container.children);
    if (items.length === 0) return setChipRowCount(1);

    const tops = items.map(el => el.offsetTop).sort((a, b) => a - b);
    const TOLERANCE = 4; // px, absorbs sub-pixel rounding

    let rows = 1;
    let lastTop = tops[0];
    tops.forEach(top => {
      if (top - lastTop > TOLERANCE) {
        rows += 1;
        lastTop = top;
      }
    });

    setChipRowCount(rows);
  };

  useLayoutEffect(() => {
    calculateChipRows();
  }, [selectedOptionsInstant, searchTerm]);

  useEffect(() => {
    const container = chipsWrapRef.current;
    if (!container) return;
    const ro = new ResizeObserver(() => calculateChipRows());
    ro.observe(container);
    return () => ro.disconnect();
  }, []);

  useEffect(() => {
    setSelectedPatientOptions(initialSelectedOptionsInstant || [])
  }, [])

  useEffect(() => {
    if (searchTerm.length > 2) {
      const abortController = new AbortController();

      if (type === "Payment" || type === "Claim" || type === "PatientTask") {
        fetchOptions(postBody, abortController);
      } else {
        fetchOptions(searchTerm, abortController);
      }

      return () => { abortController.abort(); };
    }
  }, [searchTerm]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsListOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);

  useEffect(() => {
    if (inputRef3.current) {
      if (initialSelectedOptionsInstant?.length === 0) {
        inputRef3.current.focus();
      }
    }
  }, [selectedOptionsInstant]);

  /// To Open in child Window
  const openChildWindow = (item) => {
    if (props?.handleOpenCheck && item?.length > 0) {
      props?.handleOpenCheck(item?.[0])
    }
  }

  const handleToggleOptionsforInstant = (option) => {
    setSearchTerm('');
    ResetOptionInstant();
    const isSelected = selectedOptionsInstant.some((selected) => String(selected.value) === String(option.value));
    if (isSelected) {
      datainstant = selectedOptionsInstant.filter((selected) => String(selected.value) !== String(option.value))
      setSelectedOptionsInstant(datainstant);
      setSelectedPatientOptions(datainstant);
      const index = -1;

    } else {
      datainstant = [...selectedOptionsInstant, option]
      if (props?.openChildWindowOnSelection === true) {
        openChildWindow(datainstant);
        return;
      }
      setSelectedOptionsInstant(datainstant);
      setSelectedPatientOptions(datainstant);
    }
    onSelect(datainstant, name);
  };

  const handleRemoveOptioninstant = (selected, index) => {
    let data = []
    ResetOptionInstant()
    if (selectedOptionsInstant.length > 0) {
      const optionToRemove = selected
      data = selectedOptionsInstant?.filter((selected) => selected?.value !== optionToRemove?.value)
      setSelectedOptionsInstant(data)
      setSelectedPatientOptions(data);
      onSelect(data, name)
    }
  };
  const handleSearch = (event) => {
    const term = event.target.value;
    if (!isNull(term)) {
      if (type === "Payment" || type === "Claim" || type === "PatientTask") {
        postBody['Search'] = term;
      }
      setSearchTerm(term);

    } else {
      if (type === "Payment" || type === "Claim" || type === "PatientTask") {
        postBody['Search'] = term
      }
      setSearchTerm(term);
      setOptions([])   // removing 
    }
  };

  const ResetOptionInstant = () => {
    setSearchTerm('')
    setOptions([])
    if (props?.SuperSearchView === "DetailedView") {
      handleSpanClick();
    }
  }

  const handleScroll = (index) => {
    const list = listRef.current;
    if (list) {
      const listItems = list.querySelectorAll('#ul-list-for-auto li');
      if (listItems && listItems[index]) {
        const selectedElement = listItems[index];
        list.scrollTop = selectedElement.offsetTop - list.offsetTop;
      }
    }
  };
  const inputRef = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);

  // Function to handle the span click and move focus to the input field
  const handleSpanClick = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const onKeyDownPressed = (e) => {
    if (e.keyCode === 40) {   // onDownkeyPress
      // debugger
      if (bool === false) {
        counter = counter + 2
      }
      handleScroll(counter);
      lastKeyPressed = e.keyCode
      if (options[counter] !== undefined) {
        if (counter <= options.length) {
          const listItems = document.querySelectorAll('#ul-list-for-auto li');
          listItems.forEach(function (item, index) {
            if (index === counter) {
              item.classList.add('ar-sup_DU');
            } else {
              item.classList.remove('ar-sup_DU');
            }
          });
          counter = counter + 1
          bool = true
        }
      }
    }
    if (e.keyCode === 38) {
      // onUpkeyPress
      if (bool === true) {
        counter = counter - 2
      }
      handleScroll(counter);
      lastKeyPressed = e.keyCode
      if (options[counter] !== undefined) {
        if (counter <= options.length) {
          const listItems = document.querySelectorAll('#ul-list-for-auto li');
          listItems.forEach(function (item, index) {
            if (index === counter) {
              item.classList.add('ar-sup_DU');
            } else {
              item.classList.remove('ar-sup_DU');
            }
          });
          counter = counter - 1
        }
        bool = false
      }
    }
    if (e.keyCode === 13) // User pressed the ENTER key
    {
      //   setisItemSelected(true)
      let index = counter;
      if (lastKeyPressed === 40) {
        index = index - 1  // onDownkeyPress
      } else if (lastKeyPressed === 38) {
        index = index + 1  // onUpkeyPress
      }
      if (options.length > 0) {
        handleToggleOptionsforInstant(options[index]);
      } else {
        // handleonBlur(e)
      }
      // handleScroll(counter);
    }
    if (e.keyCode === 27) { // IF USER PRESSES ESC KEY THEN RESET THE COMPONENT TO ITS ORIGINAL STATE
      //   props.getSelectedData(null);
      //   setOptions([]);
      //   setNoResult(!noResult);
    }
    if (e.keyCode === 8) { // Backspace
      if (searchTerm !== '') {
      }
      else {
        if (selectedOptionsInstant && selectedOptionsInstant.length > 0) {
          handleToggleOptionsforInstant(selectedOptionsInstant[selectedOptionsInstant.length - 1])
        }
      }
    }
  }
  let userInitials = '';
  const getInitials = (name) => {
    const nameArray = name.split(' ');
    if (nameArray.length >= 2) {
      return nameArray[1][0] + nameArray[0][0];
    } else if (nameArray.length === 1) {
      return nameArray[0][0];
    }
    return '';
  };


  // userInitials = getInitials(name)
  return (
    <div className={`${styles.sup_auto_suggest} ${styles.insurance_auto}  ar-options-list `} ref={wrapperRef}>
      {/* SuperSearchMultiple for Detailed View */    /* Multi select input in case of more than 1 record */
        props?.SuperSearchView === "DetailedView" ?
          <div className={`selected_options  server-scroll d-flex align-items-center justify-content-between detailed_view gap-0 ${selectedOptionsInstant.length === 0 ? "d-none" : ""} ${props?.DesignView === "GroupAppointmentMultiline" ? `ar_group-appointment-multiple-rows row-${chipRowCount}` : ""}`} ref={buttonRef}>
            <div className={`d-flex align-items-center gap-1 w-100 ${props?.DesignView === "GroupAppointmentMultiline" ? 'flex-wrap' : ""} `} ref={chipsWrapRef}>
              {selectedOptionsInstant?.map((selected, index) => (
                <div className='d-flex align-items-center ar-selected' >
                  <p className='text fs-10 font-m validation_message text-nowrap'>
                    {selected?.display}
                  </p>
                  <i className="icon-Group-3311" onClick={() => handleRemoveOptioninstant(selected, index)}></i>
                </div>
              ))}
              <div className={`input w-100 d-flex flex-row align-items-center me-1 ${selectedOptionsInstant?.length === 1 ? 'width' : ''}`}>
                <input
                  ref={inputRef3}
                  value={searchTerm}
                  onChange={handleSearch}
                  onClick={() => { setIsListOpen(true); }}
                  className='form-control bg-transparent'
                  onKeyDown={(e) => {
                    onKeyDownPressed(e);
                  }}
                />
                <div>
                  {isLoading === true ?
                    <div className='last_loader ar-small-loader'>
                      <div class="circle circle1"></div>
                      <div class="circle circle2"></div>
                    </div>
                    :
                    <i className="icon-lite-cross fs-16" onClick={() => { setSelectedOptionsInstant([]); setSelectedPatientOptions([]); setSearchParam(prev => ({ ...prev, [name]: "" }));; setSearchTerm(''); setOptions([]) }}></i>
                  }
                </div>
              </div>
            </div>
          </div> :
          <div className={'selected_options  server-scroll'} ref={buttonRef}>
            {selectedOptionsInstant?.map((selected, index) => (
              <div className='d-flex align-items-center ar-selected' >
                <p className='text text-white validation_message text-nowrap'>
                  {selected?.display}
                </p>
                <i className="bi bi-x text-white" onClick={() => handleRemoveOptioninstant(selected, index)}></i>
              </div>
            ))}
          </div>}

      {props?.SuperSearchView === "DetailedView" ?
        /* SuperSearchMultiple for Detailed View */
        <div className={`input-group ${styles[props.sup_inp]}`}>
          <div className='d-flex align-items-center justify-content-between pe-4 me-2 rounded-5 br-top-1 br-bottom-1 br-left-1 br-clr form-control w-100 bg-white'>
            {selectedOptionsInstant.length === 0 ?
              <>
                <input
                  ref={inputRef2}
                  value={selectedOptionsInstant?.length > 0 ? "" : searchTerm}
                  onChange={handleSearch}
                  onClick={() => setIsListOpen(true)}
                  className='border-0 bg-transparent p-0'
                  onKeyDown={(e) => {
                    onKeyDownPressed(e);
                    // handleCommonKeyDown(e);
                  }}
                  placeholder='Type 3 or more characters to search...'
                />
                <div className={`${selectedOptionsInstant.length === 0 ? 'd-block' : 'd-none'}`}>
                  {isLoading === true ?
                    <div className='last_loader ar-small-loader'>
                      <div class="circle circle1"></div>
                      <div class="circle circle2"></div>
                    </div>
                    : ''}
                </div>

              </> : null}

          </div>
          <div className="search-arrow">
            <span className="dropdown_icon position-absolute top-0 end-1 detailed">
              <i className='icon-Clip-path-group fs-15'></i>
            </span>
          </div>
          {/* SuperSearchMultiple for Detailed Patient View*/}
          {props?.DetailedView === "Patient" ?
            <>
              {isListOpen ?
                (<div ref={listRef} className={`${styles.sup_listWrapper} ${styles.insurance_list_wrap} hk-supListBOX mt-4 za-super-search-list `} >
                  <p className='za-super-head text font-m fst-italic fs-10 za-blue-clr'>{options?.length || '0'} Result(s) Found</p>
                  <ul className="list-group za-super-search-cards" id="ul-list-for-auto">
                    {options?.length > 0 ?
                      (options?.map((option, index) => (
                        <li className={`za-supercard za-br-tb ${selectedOptionsInstant.map(item => item.value)?.includes(option.value) ? 'ar-sup_DU' : ''}`}
                          key={option.value}
                          onClick={() => { handleToggleOptionsforInstant(option); }}
                          id={index}>

                          {props?.DetailedView === "Patient" ?
                            <>
                              <div className='d-flex gap-1 align-items-center'>
                                <div className="circle img-container s-40">
                                  <p className={`align-items-center d-flex h-100 heading justify-content-center w-100 fs-14 text-white za-male ${isMale(option.Gender) ? 'za-male' : isFemale(option.Gender) ? 'za-female' : 'za-others'}`}>
                                    {userInitials = getInitials(option.display)}
                                    {/* <InitialLetters classes={""} name={option.display} splitBy={','} /> */}
                                  </p>
                                </div>
                                <div className='w-100 overflow-hidden'>

                                  <div className='d-flex align-items-center'>

                                    <div className='d-flex align-items-end gap-1 col-md-8'>
                                      {/* <span class="icon-searchlist-sumry fs-13"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span></span> */}
                                      <SearchLetterHighlighted classes={'heading text-nowrap validation_message'} searchValue={searchTerm} text={option.display} />
                                      <p className='text fs-11 ar-light-color'>{option.DOB} </p>
                                      <p className='text fs-11 ar-light-color'>{option.Age ? <>({option.Age})</> : <></>}</p>
                                      <p className={'text fs-11 ar-light-color'} >{option.Gender}</p>
                                    </div>
                                    <div className="col-md-4 text-end pe-1">
                                      {/* <p className='text fs-12 fst-italic font-m ar-light-color'>{option.AccountNumber}</p> */}
                                      <SearchLetterHighlighted classes={'text fs-12 fst-italic font-m ar-light-color'} searchValue={searchTerm} text={option.AccountNumber} />
                                    </div>
                                  </div>


                                  <p className='text font-m fs-11 fst-italic drk-green-clr'>{option.InsuranceName}</p>
                                  <div className='d-flex align-items-center'>
                                    {option.SubscriberID ?
                                      <div className='d-flex gap-1 col-md-6'>
                                        <p className='text fs-11 text-nowrap'>Subcriber ID:</p>
                                        {/* <p className='text fs-11 text-nowrap validation_message' title={option.SubscriberID}>{option.SubscriberID}</p> */}
                                        <SearchLetterHighlighted classes={'text fs-11 text-nowrap validation_message'} searchValue={searchTerm} text={option.SubscriberID} />
                                      </div> : <></>}

                                    {isHomeCareCheck ?
                                      <>
                                        {option.MedicAidNo ?
                                          <div className='d-flex gap-1 col-md-6 justify-content-end'>
                                            <p className='text fs-11 font-m text-nowrap'>Medicaid #</p>
                                            <SearchLetterHighlighted classes={'text fs-11 font-m text-nowrap validation_message'} searchValue={searchTerm} text={option.MedicAidNo} />
                                            {/* <p className='text fs-11 font-m text-nowrap validation_message' title={option.MedicAidNo}>{option.MedicAidNo}</p> */}
                                          </div> : <></>}
                                      </>
                                      : <></>}
                                  </div>

                                </div>
                              </div>

                            </> : <></>}
                        </li>
                      ))) :
                      <div className='d-flex gap-01'>
                        <div className="list-group w-100" id="ul-list-for-auto">
                          <p className={styles.sup_list_group_item} >No Data Found !</p>
                        </div>
                      </div>}
                  </ul>
                </div>) : <></>}
            </> :
            props?.DetailedView === "PatientTask" ?
              <>
                {isListOpen ?
                  (<div ref={listRef} className={`${styles.sup_listWrapper} ${styles.insurance_list_wrap} hk-supListBOX mt-4 za-super-search-list `} >
                    <p className='za-super-head text font-m fst-italic fs-10 za-blue-clr'>{options?.length || '0'} Result(s) Found</p>
                    <ul className="list-group za-super-search-cards" id="ul-list-for-auto">
                      {options?.length > 0 ?
                        (options?.map((option, index) => (
                          <li className={`za-supercard za-br-tb ${selectedOptionsInstant.map(item => String(item.value))?.includes(String(option.value)) ? 'ar-sup_DU' : ''}`}
                            key={option.value}
                            onClick={() => { handleToggleOptionsforInstant(option); }}
                            id={index}>

                            {props?.DetailedView === "PatientTask" ?
                              <>
                                <div className='d-flex gap-1 align-items-center'>
                                  <div className="circle img-container s-40">
                                    <p className={`align-items-center d-flex h-100 heading justify-content-center w-100 fs-14 text-white za-male ${isMale(option.Gender) ? 'za-male' : isFemale(option.Gender) ? 'za-female' : 'za-others'}`}>
                                      {userInitials = getInitials(option.display)}
                                    </p>
                                  </div>
                                  <div className='w-100 overflow-hidden'>

                                    <div className='d-flex align-items-center'>

                                      <div className='d-flex align-items-end gap-1 col-md-8'>
                                        {/* <span class="icon-searchlist-sumry fs-13"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span></span> */}
                                        <SearchLetterHighlighted classes={'heading text-nowrap validation_message'} searchValue={postBody['Search']} text={option.display} />
                                        <p className='text fs-11 ar-light-color'>{option.DOB} </p>
                                        <p className='text fs-11 ar-light-color'>{option.AGE ? <>({option.AGE})</> : <></>}</p>
                                        <p className={'text fs-11 ar-light-color'} >{option.Gender}</p>
                                      </div>
                                      <div className="col-md-4 text-end pe-1">
                                        {/* <p className='text fs-12 fst-italic font-m ar-light-color'>{option.AccountNumber}</p> */}
                                        <SearchLetterHighlighted classes={'text fs-12 fst-italic font-m ar-light-color'} searchValue={postBody['Search']} text={option.AccountNumber} />
                                      </div>
                                    </div>


                                    {/* <p className='text font-m fs-11 fst-italic drk-green-clr'>{option.InsuranceName}</p> */}
                                    <div className='d-flex align-items-center'>
                                      <div className='col-md-7'>
                                        <p className='text font-m fs-11 fst-italic drk-green-clr'>{option.InsuranceName}</p>
                                      </div>
                                      <div className="col-md-5 text-end">
                                        <p className='text font-m fs-11 drk-green-clr'>{PhoneNumberFormat(option?.MobileNumber)}</p>
                                      </div>
                                    </div>
                                    <div className='d-flex align-items-center'>
                                      {/* {option.SubscriberID ? */}
                                      <div className='d-flex gap-1 col-md-6'>
                                        <p className='text fs-11 text-nowrap'>Subcriber ID:</p>
                                        {/* <p className='text fs-11 text-nowrap validation_message' title={option.SubscriberID}>{option.SubscriberID}</p> */}
                                        <SearchLetterHighlighted classes={'text fs-11 text-nowrap validation_message'} searchValue={postBody['Search']} text={option.SubscriberID} />
                                      </div>
                                      {/* : <div></div>} */}
                                      <div className=' d-flex gap-1 col-md-6 justify-content-end'>
                                        <p className='text fs-11 font-m za-pat-copay pat-bal text-nowrap'>Pat Bal: <AmountFormatter amount={option?.PatBal} /></p>
                                        <p className='text fs-11 font-m za-pat-copay copay text-nowrap'>Copay: <AmountFormatter amount={option?.copay} /></p>
                                      </div>
                                      {isHomeCareCheck ?
                                        <>
                                          {option.MedicaidNo ?
                                            <div className='d-flex gap-1 col-md-6 justify-content-end'>
                                              <p className='text fs-11 font-m text-nowrap'>Medicaid #</p>
                                              <SearchLetterHighlighted classes={'text fs-11 font-m text-nowrap validation_message'} searchValue={postBody['Search']} text={option.MedicaidNo} />
                                              {/* <p className='text fs-11 font-m text-nowrap validation_message' title={option.MedicAidNo}>{option.MedicAidNo}</p> */}
                                            </div> : <></>}
                                        </>
                                        : <></>}
                                    </div>

                                  </div>
                                </div>

                              </> : <></>}
                          </li>
                        ))) :
                        <div className='d-flex gap-01'>
                          <div className="list-group w-100" id="ul-list-for-auto">
                            <p className={styles.sup_list_group_item} >No Data Found !</p>
                          </div>
                        </div>}
                    </ul>
                  </div>) : <></>}
              </> :
              props?.DetailedView === "Caregiver" ?
                <>
                  {isListOpen ?
                    (<div ref={listRef} className={`${styles.sup_listWrapper} ${styles.insurance_list_wrap} hk-supListBOX mt-4 za-super-search-list `} >
                      <p className='za-super-head text font-m fst-italic fs-10 za-blue-clr'>{options?.length || '0'} Result(s) Found</p>
                      <ul className="list-group za-super-search-cards" id="ul-list-for-auto">
                        {options?.length > 0 ?
                          (options?.map((option, index) => (
                            <li className={`za-supercard za-br-tb d-flex align-items-center ${selectedOptionsInstant.map(item => String(item?.value))?.includes(String(option.value)) ? 'ar-sup_DU' : ''}`}
                              key={option.value}
                              onClick={() => { handleToggleOptionsforInstant(option); }}
                              id={index}>
                              {props?.DetailedView === "Caregiver" ?
                                <>
                                  <div className='d-flex gap-1 align-items-center'>
                                    <div className="circle img-container s-40">
                                      <p className={`align-items-center d-flex h-100 heading justify-content-center w-100 fs-14 text-white za-male ${isMale(option.Gender) ? 'za-male' : isFemale(option.Gender) ? 'za-female' : 'za-others'}`}>
                                        <InitialLetters classes={""} name={option.display} splitBy={','} />
                                      </p>
                                    </div>
                                    <div className='w-100 overflow-hidden'>

                                      <div className='d-flex align-items-center'>

                                        <div className='d-flex align-items-end gap-1 col-md-8'>
                                          {/* <span class="icon-searchlist-sumry fs-13"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span></span> */}
                                          <SearchLetterHighlighted classes={'heading text-nowrap validation_message'} searchValue={searchTerm} text={option.display} />
                                          <p className='text fs-11 ar-light-color'>{option.DOB} </p>
                                          <p className='text fs-11 ar-light-color'>{option.Age ? <>({option.Age})</> : <></>}</p>
                                          <p className={'text fs-11 ar-light-color'} >{option.Gender}</p>
                                        </div>
                                        <div className="col-md-4 text-end pe-1">
                                          {/* <p className='text fs-12 fst-italic font-m ar-light-color'>{option.AccountNumber}</p> */}
                                          <SearchLetterHighlighted classes={'text fs-12 fst-italic font-m ar-light-color'} searchValue={searchTerm} text={option.AccountNumber} />
                                        </div>
                                      </div>


                                      <p className='text font-m fs-11 fst-italic drk-green-clr'>{option.InsuranceName}</p>
                                      <div className='d-flex align-items-center'>
                                        {option.SubscriberID ?
                                          <div className='d-flex gap-1 col-md-6'>
                                            <p className='text fs-11 text-nowrap'>Subcriber ID:</p>
                                            {/* <p className='text fs-11 text-nowrap validation_message' title={option.SubscriberID}>{option.SubscriberID}</p> */}
                                            <SearchLetterHighlighted classes={'text fs-11 text-nowrap validation_message'} searchValue={searchTerm} text={option.SubscriberID} />
                                          </div> : <></>}

                                        {isHomeCareCheck ?
                                          <>
                                            {option.MedicAidNo ?
                                              <div className='d-flex gap-1 col-md-6 justify-content-end'>
                                                <p className='text fs-11 font-m text-nowrap'>Medicaid #</p>
                                                <SearchLetterHighlighted classes={'text fs-11 font-m text-nowrap validation_message'} searchValue={searchTerm} text={option.MedicAidNo} />
                                                {/* <p className='text fs-11 font-m text-nowrap validation_message' title={option.MedicAidNo}>{option.MedicAidNo}</p> */}
                                              </div> : <></>}
                                          </>
                                          : <></>}
                                      </div>

                                    </div>
                                  </div>

                                </> : <></>}
                            </li>
                          ))) :
                          <div className='d-flex gap-01'>
                            <div className="list-group w-100" id="ul-list-for-auto">
                              <p className={styles.sup_list_group_item} >No Data Found !</p>
                            </div>
                          </div>}
                      </ul>
                    </div>) : <></>}
                </> :
                props?.DetailedView === "Claim" ?
                  <>
                    {isListOpen ?
                      (
                        <div ref={listRef} className={`${styles.sup_listWrapper} ${styles.insurance_list_wrap} hk-supListBOX mt-4 za-super-search-list `} >
                          <p className='za-super-head text font-m fst-italic fs-10 za-blue-clr'>{options?.length || '0'} Result(s) Found</p>
                          <ul className="list-group za-super-search-cards" id="ul-list-for-auto">


                            {options?.length > 0 ?
                              (options?.map((option, index) => (
                                // <li className={`za-supercard za-br-tb ${selectedOptionsInstant.map(item => item.value)?.includes(option.value) ? 'ar-sup_DU' : ''}`}
                                //   key={option.value}
                                //   onClick={() => { handleToggleOptionsforInstant(option); }}
                                //   id={index}>
                                //   {props?.DetailedView === "Caregiver" ?
                                //     <>
                                //       <div className='d-flex gap-1 align-items-center'>
                                //         <div className="circle img-container s-40">
                                //           <p className={`align-items-center d-flex h-100 heading justify-content-center w-100 fs-14 text-white za-male ${isMale(option.Gender) ? 'za-male' : isFemale(option.Gender) ? 'za-female' : 'za-others'}`}>
                                //             <InitialLetters classes={""} name={option.display} splitBy={','} />
                                //           </p>
                                //         </div>
                                //         <div className='w-100 overflow-hidden'>

                                //           <div className='d-flex align-items-center'>

                                //             <div className='d-flex align-items-end gap-1 col-md-8'>
                                //               {/* <span class="icon-searchlist-sumry fs-13"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span></span> */}
                                //               <SearchLetterHighlighted classes={'heading text-nowrap validation_message'} searchValue={searchTerm} text={option.display} />
                                //               <p className='text fs-11 ar-light-color'>{option.DOB} </p>
                                //               <p className='text fs-11 ar-light-color'>{option.Age ? <>({option.Age})</> : <></>}</p>
                                //               <p className={'text fs-11 ar-light-color'} >{option.Gender}</p>
                                //             </div>
                                //             <div className="col-md-4 text-end pe-1">
                                //               {/* <p className='text fs-12 fst-italic font-m ar-light-color'>{option.AccountNumber}</p> */}
                                //               <SearchLetterHighlighted classes={'text fs-12 fst-italic font-m ar-light-color'} searchValue={searchTerm} text={option.AccountNumber} />
                                //             </div>
                                //           </div>


                                //           <p className='text font-m fs-11 fst-italic drk-green-clr'>{option.InsuranceName}</p>
                                //           <div className='d-flex align-items-center'>
                                //             {option.SubscriberID ?
                                //               <div className='d-flex gap-1 col-md-6'>
                                //                 <p className='text fs-11 text-nowrap'>Subcriber ID:</p>
                                //                 {/* <p className='text fs-11 text-nowrap validation_message' title={option.SubscriberID}>{option.SubscriberID}</p> */}
                                //                 <SearchLetterHighlighted classes={'text fs-11 text-nowrap validation_message'} searchValue={searchTerm} text={option.SubscriberID} />
                                //               </div> : <></>}

                                //             {isHomeCareCheck ?
                                //               <>
                                //                 {option.MedicAidNo ?
                                //                   <div className='d-flex gap-1 col-md-6 justify-content-end'>
                                //                     <p className='text fs-11 font-m text-nowrap'>Medicaid #</p>
                                //                     <SearchLetterHighlighted classes={'text fs-11 font-m text-nowrap validation_message'} searchValue={searchTerm} text={option.MedicAidNo} />
                                //                     {/* <p className='text fs-11 font-m text-nowrap validation_message' title={option.MedicAidNo}>{option.MedicAidNo}</p> */}
                                //                   </div> : <></>}
                                //               </>
                                //               : <></>}
                                //           </div>

                                //         </div>
                                //       </div>

                                //     </> : <></>}
                                // </li>
                                <>

                                  <div
                                    className={`za-supercard za-br-tb d-flex align-items-center ${selectedOptionsInstant.map(item => String(item.value))?.includes(String(option.value)) ? 'ar-sup_DU' : ''}`}
                                    key={option.value}
                                    onClick={() => { handleToggleOptionsforInstant(option); }}
                                    id={index}>
                                    <div className='circle-cash-bg d-flex justify-content-center align-items-center'>
                                      <span class="icon-Summary-icon fs-20"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span></span>
                                    </div>
                                    <div className="w-100 over-flow-hidden">
                                      <div className="d-flex align-items-center">
                                        <div className="d-flex align-items-center gap-1 col-md-8">
                                          <p className='text font-m fs-12'>Claim # {option?.display}</p>
                                          <p className='heading fs-11 text-bg-M d-flex justify-content-center'>{option?.ClaimType}</p>
                                        </div>
                                        <div className="col-md-4 text-end pe-1">
                                          <HandleStatus Status={option?.BillingStatus} />
                                          {/* {HandleStatus(option?.BillingStatus)} */}
                                        </div>
                                      </div>

                                      <div className="d-flex align-items-center">
                                        <div className="d-flex align-items-center gap-1 col-md-8">
                                          <p className='text fs-11 '>{option?.Patient}</p>
                                        </div>

                                        <div className="col-md-4 text-end pe-1">
                                          <p></p>
                                        </div>

                                      </div>

                                      <div className="d-flex align-items-center">
                                        <div className="d-flex align-items-center gap-1 col-md-5">
                                          <p title={option?.InsuranceName} className='text font-m fs-11 fst-italic drk-green-clr validation_message text-nowrap za-claims '>{option?.InsuranceName}</p>
                                        </div>

                                        <div className="col-md-7 pe-1">
                                          <div className='d-flex gap-01 justify-content-end '>
                                            <p className='text fs-11 font-m za-bpb billed-bg'>Billed : <AmountFormatter amount={option?.Billed} /></p>
                                            <p className='text fs-11 font-m za-bpb paid-bg'>Paid : <AmountFormatter amount={option?.InsurancePaid} /></p>
                                            <p className='text fs-11 font-m za-bpb bal-bg'>Bal : <AmountFormatter amount={option?.InsuranceBalance} /></p>
                                          </div>
                                        </div>

                                      </div>
                                    </div>
                                    {/* <div className=''>
                                    <div className='d-flex align-items-center gap-01'>
                                        <p className='text font-m fs-12'>Claim # {item.Field1}</p>
                                        <p className='heading fs-11 text-bg-M d-flex justify-content-center'>{item.Field7}</p>
                                    </div>




                                </div> */}
                                  </div>
                                </>
                              ))) :
                              <div className='d-flex gap-01'>
                                <div className="list-group w-100" id="ul-list-for-auto">
                                  <p className={styles.sup_list_group_item} >No Data Found !</p>
                                </div>
                              </div>}
                          </ul>
                        </div>
                      ) : <></>}
                  </> :
                  props?.DetailedView === "Payment" ?
                    <>
                      {isListOpen ?
                        (<div ref={listRef} className={`${styles.sup_listWrapper} ${styles.insurance_list_wrap} hk-supListBOX mt-4 za-super-search-list `} >
                          <p className='za-super-head text font-m fst-italic fs-10 za-blue-clr'>{options?.length || '0'} Result(s) Found</p>
                          <ul className="list-group za-super-search-cards" id="ul-list-for-auto">
                            {options?.length > 0 ?
                              (options?.map((option, index) => (
                                // <li className={`za-supercard za-br-tb ${selectedOptionsInstant.map(item => item.value)?.includes(option.value) ? 'ar-sup_DU' : ''}`}
                                //   key={option.value}
                                //   onClick={() => { handleToggleOptionsforInstant(option); }}
                                //   id={index}>
                                //   {props?.DetailedView === "Caregiver" ?
                                //     <>
                                //       <div className='d-flex gap-1 align-items-center'>
                                //         <div className="circle img-container s-40">
                                //           <p className={`align-items-center d-flex h-100 heading justify-content-center w-100 fs-14 text-white za-male ${isMale(option.Gender) ? 'za-male' : isFemale(option.Gender) ? 'za-female' : 'za-others'}`}>
                                //             <InitialLetters classes={""} name={option.display} splitBy={','} />
                                //           </p>
                                //         </div>
                                //         <div className='w-100 overflow-hidden'>

                                //           <div className='d-flex align-items-center'>

                                //             <div className='d-flex align-items-end gap-1 col-md-8'>
                                //               {/* <span class="icon-searchlist-sumry fs-13"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span></span> */}
                                //               <SearchLetterHighlighted classes={'heading text-nowrap validation_message'} searchValue={searchTerm} text={option.display} />
                                //               <p className='text fs-11 ar-light-color'>{option.DOB} </p>
                                //               <p className='text fs-11 ar-light-color'>{option.Age ? <>({option.Age})</> : <></>}</p>
                                //               <p className={'text fs-11 ar-light-color'} >{option.Gender}</p>
                                //             </div>
                                //             <div className="col-md-4 text-end pe-1">
                                //               {/* <p className='text fs-12 fst-italic font-m ar-light-color'>{option.AccountNumber}</p> */}
                                //               <SearchLetterHighlighted classes={'text fs-12 fst-italic font-m ar-light-color'} searchValue={searchTerm} text={option.AccountNumber} />
                                //             </div>
                                //           </div>


                                //           <p className='text font-m fs-11 fst-italic drk-green-clr'>{option.InsuranceName}</p>
                                //           <div className='d-flex align-items-center'>
                                //             {option.SubscriberID ?
                                //               <div className='d-flex gap-1 col-md-6'>
                                //                 <p className='text fs-11 text-nowrap'>Subcriber ID:</p>
                                //                 {/* <p className='text fs-11 text-nowrap validation_message' title={option.SubscriberID}>{option.SubscriberID}</p> */}
                                //                 <SearchLetterHighlighted classes={'text fs-11 text-nowrap validation_message'} searchValue={searchTerm} text={option.SubscriberID} />
                                //               </div> : <></>}

                                //             {isHomeCareCheck ?
                                //               <>
                                //                 {option.MedicAidNo ?
                                //                   <div className='d-flex gap-1 col-md-6 justify-content-end'>
                                //                     <p className='text fs-11 font-m text-nowrap'>Medicaid #</p>
                                //                     <SearchLetterHighlighted classes={'text fs-11 font-m text-nowrap validation_message'} searchValue={searchTerm} text={option.MedicAidNo} />
                                //                     {/* <p className='text fs-11 font-m text-nowrap validation_message' title={option.MedicAidNo}>{option.MedicAidNo}</p> */}
                                //                   </div> : <></>}
                                //               </>
                                //               : <></>}
                                //           </div>

                                //         </div>
                                //       </div>

                                //     </> : <></>}
                                // </li>
                                <>

                                  <div
                                    className={`za-supercard za-br-tb d-flex align-items-center justify-content-between ${selectedOptionsInstant.map(item => String(item.value))?.includes(String(option.value)) ? 'ar-sup_DU' : ''}`}
                                    key={option.value}
                                    onClick={() => { handleToggleOptionsforInstant(option); }}
                                    id={index}
                                  >
                                    <div className={`d-flex align-items-center gap-2`}>
                                      <div className='circle-cash-bg d-flex justify-content-center align-items-center'>
                                        <span class="icon-circle-cash fs-20"><span class="path1"></span><span class="path2"></span></span>
                                      </div>

                                      <div className='d-flex flex-column'>
                                        <div className='d-flex align-items-center gap-01'>
                                          <p className='text font-m fs-12'>Check #</p>
                                          <SearchLetterHighlighted classes={'heading text-nowrap validation_message'} searchValue={searchTerm} text={option?.display} />
                                          <p className='heading fs-11 text-bg-M d-flex justify-content-center'>{option?.Type === "Manual Payment" ? "M" : "E"}</p>
                                        </div>

                                        <p className='text font-m fs-11 fst-italic drk-green-clr'>{option?.InsuranceName}</p>
                                        <div className='d-flex gap-1'>
                                          <p className='text fs-11'>Chk Date:</p>
                                          <p className='text fs-11'>{option?.CheckDate}</p>
                                        </div>
                                      </div>
                                    </div>
                                    <div className='d-flex flex-column align-items-end'>
                                      <p className='text fs-12 font-m partially-bg'>{option?.PostingStatus}</p>
                                      <p></p>
                                      <p className='text fs-11 font-m chk-amt-bg'>Chk Amt : <AmountFormatter amount={option?.CheckAmount} /></p>
                                    </div>
                                  </div>


                                </>
                              ))) :
                              <div className='d-flex gap-01'>
                                <div className="list-group w-100" id="ul-list-for-auto">
                                  <p className={styles.sup_list_group_item} >No Data Found !</p>
                                </div>
                              </div>}
                          </ul>
                        </div>) : <></>}
                    </> :
                    props?.DetailedView === "Encounter" ?
                      <>
                        {isListOpen ?
                          (<div ref={listRef} className={`${styles.sup_listWrapper} ${styles.insurance_list_wrap} hk-supListBOX mt-4 za-super-search-list `} >
                            <p className='za-super-head text font-m fst-italic fs-10 za-blue-clr'>{options?.length || '0'} Result(s) Found</p>
                            <ul className="list-group za-super-search-cards" id="ul-list-for-auto">
                              {options?.length > 0 ?
                                (options?.map((option, index) => (
                                  <>
                                    <div
                                      className={`za-supercard za-br-tb d-flex flex-column gap-1 ${selectedOptionsInstant.map(item => String(item.value))?.includes(String(option.value)) ? 'ar-sup_DU' : ''}`}
                                      key={option.value}
                                      onClick={() => { handleToggleOptionsforInstant(option); }}
                                      id={index}
                                    >
                                      {/* <div className={`d-flex align-items-center gap-2`}>
                                      <div className='circle-cash-bg d-flex justify-content-center align-items-center'>
                                        <span class="icon-circle-cash fs-20"><span class="path1"></span><span class="path2"></span></span>
                                      </div>

                                      <div className='d-flex flex-column'>
                                        <div className='d-flex align-items-center gap-01'>
                                          <p className='text font-m fs-12'>Check # {option?.display}</p>
                                          <p className='heading fs-11 text-bg-M d-flex justify-content-center'>{option?.Type === "Manual Payment" ? "M" : "E"}</p>
                                        </div>

                                        <p className='text font-m fs-11 fst-italic drk-green-clr'>{option?.InsuranceName}</p>
                                        <div className='d-flex gap-1'>
                                          <p className='text fs-11'>Chk Date:</p>
                                          <p className='text fs-11'>{option?.CheckDate}</p>
                                        </div>
                                      </div>
                                    </div>
                                    <div className='d-flex flex-column align-items-end'>
                                      <p className='text fs-12 font-m partially-bg'>{option?.PostingStatus}</p>
                                      <p></p>
                                      <p className='text fs-11 font-m chk-amt-bg'>Chk Amt : <AmountFormatter amount={option?.CheckAmount} /></p>
                                    </div> */}
                                      <div className="d-flex align-items-center justify-content-between">
                                        <p className='heading font-m'>06/03/2025 - 04:00 PM</p>
                                        <p className='pill Pending-Arrival'>Pending-Arrival</p>
                                      </div>
                                      <div className="d-flex align-items-center gap-5">
                                        <p className='text fs-11'>CC:</p>
                                        <p className='fs-11 text text-nowrap validation_message'>Dizziness, heart Ache, chol...</p>
                                      </div>
                                    </div>
                                  </>
                                ))) :
                                <div className='d-flex gap-01'>
                                  <div className="list-group w-100" id="ul-list-for-auto">
                                    <p className={styles.sup_list_group_item} >No Data Found !</p>
                                  </div>
                                </div>}
                            </ul>
                          </div>) : <></>}
                      </> :
                      <>
                        {isListOpen ?
                          (<div ref={listRef} className={`${styles.sup_listWrapper} ${styles.insurance_list_wrap} hk-supListBOX mt-4 za-super-search-list min-w-unset`} >
                            <p className='za-super-head text font-m fst-italic fs-10 za-blue-clr'>{options?.length || '0'} Result(s) Found</p>
                            <ul className="list-group za-super-search-cards" id="ul-list-for-auto">
                              {options?.length > 0 ?
                                (options?.map((option, index) => (
                                  <li className={`za-supercard za-br-tb d-flex py-1  ${selectedOptionsInstant.map(item => item.value)?.includes(option.value) ? 'ar-sup_DU' : ''}`}
                                    key={option.value}
                                    onClick={() => { handleToggleOptionsforInstant(option); }}
                                    id={index}>

                                    {props?.DetailedView === "" ?
                                      <>
                                        <div className='w-100'>
                                          <SearchLetterHighlighted classes={'heading text-nowrap validation_message'} searchValue={searchTerm} text={option.display} />
                                        </div>
                                      </> : <></>}
                                  </li>
                                ))) :
                                <div className='d-flex gap-01'>
                                  <div className="list-group w-100" id="ul-list-for-auto">
                                    <p className={styles.sup_list_group_item} >No Data Found !</p>
                                  </div>
                                </div>}
                            </ul>
                          </div>) : <></>}
                      </>}
        </div> : null
      }
    </div >
  );
};
export default SuperSearchMultipleServer;